// Hidden tabs keep their websocket (and every channel event listener) alive,
// so each extra tab multiplies Stream API usage. Close the socket once a tab
// has stayed in the background this long.
export const HIDDEN_TAB_DISCONNECT_DELAY_MS = 2 * 60 * 1000;

// One tab holds this Web Lock and never closes its websocket, so the unread
// count keeps flowing to the other tabs even when all of them are hidden.
export const STREAM_CONNECTION_LEADER_LOCK = "stream-connection-leader";

export const ABORT_ERROR_NAME = "AbortError";

export const MAX_IN_FLIGHT_CHANNEL_MATCH_QUERIES = 100;

export const UNREAD_COUNT_BROADCAST_CHANNEL = "stream-unread-count";
